module.exports = __webpack_public_path__ + "img/delete-icon-white.87a9383c.svg";